<template>
    <Toast />
    <div class="row">
        <div class="col-12 col-md-4">
    <StreamBarcodeReader
        @decode="(a, b, c) => onDecode(a, b, c)"
        @loaded="() => onLoaded()"
    ></StreamBarcodeReader>
        </div>
    <div class="alert alert-warning" v-if="!loaded">
        Bei der ersten Verwendung der Kamera, wirst du von deinem Browser gefragt, ob du mit der Freigabe der Kamera einverstanden bist. Dies ist eine Sicherheitsfunktion deines Browsers.
        Klicke auf “Zulassen”. AHOI übertragt keine Bildaten an den Server und kann die Bilder auch nicht einsehen. Der Barcode wird auf deinem Computer erkannt und dann als Text an die Webseite zurückgesendet.
        <hr>
        <b>Es wird nur diese Meldung angezeigt und keine Freigabeauforderung?</b>

        Dann liegt dies in den meisten Fällen daran, dass  irgendwann einmal (aus Versehen?) bei der Sicherheitsabfrage des Browsers auf “Blockieren” geklickt wurde.
        Wenn der Zugriff auf die Webcam blockiert wurde, statt die Webcam freizugeben, merkt sich der Browser dies und verweigert still und schweigend den Zugriff auf die Kamera. Du musst deshalb den Zugriff auf die Kamera wieder zulassen.
        Im Chrome und Firefox funktioniert dies sehr ähnlich: Klicken oben im Browser auf das Schloss vor der Seitenadresse. Klicken  im Chrome dann auf “Webseiteneinstellungen”. Im Firefox wählen  hingegen “Berechtigungen” aus. Auf der erscheinenden Seite kannst du die Einstellung “Kamera” auf “Zulassen” stellen. Schließe  die Seite und versuche erneut, deine Kamera freizugeben.
    </div>
    <div class="col-12 col-md-8" v-if="loaded">
        <div class="row">
            <div class="col"> Folgender Barcodetext gefunden: {{ text || "Keinen" }}</div>

        </div>
        <div class="row">
            <div class="col">Aktion</div>
            <div class="col"><select class="form-select" v-model="action">
                <option value="">Bitte auswählen</option>
                <option value="redirect">Einsendung öffnen (selbes Fenster)</option>
                <option value="redirect_windows">Einsendung öffnen (neues Fenster)</option>
                <option value="label_add">Label der Einsendung hinzufügen</option>
                <option value="label_remove" disabled>Label der Einsendung löschen</option>
                <option value="label_delete_all">Alle Labels der Einsendung löschen</option>
            </select> </div>
        </div>
        <div class="row" v-if="action=='label_add' || action=='label_remove'">
            <div class="col">Wettbewerb</div>
            <div class="col">  <Multiselect
                :closeOnSelect="true"
                :searchable="true"
                :createTag="false"
                placeholder="Wähle ein Wettbewerb"
                noOptionsText="Keine Wettbewerb vorhanden"
                noResultsText="Kein Wettbewerb gefunden"

                :filterResults="false"
                :minChars="1"
                :resolveOnLoad="true"
                :delay="0"

                v-model="competition"
                :options="async function(query) {
    return await fetchCompetitions()
  }"
            >
                <template v-slot:tag="{ option, handleTagRemove, disabled }">
                    <div class="multiselect-tag ">
                        {{ option.label }}
                    </div>
                </template>
            </Multiselect> </div>
        </div>
        <div class="row" v-if="competition!==null &&(action=='label_add' || action=='label_remove')">
            <div class="col">Labels</div>
            <div class="col">  <Multiselect
                mode="tags"
                :closeOnSelect="false"
                :searchable="true"
                :createTag="false"
                placeholder="Wähle Label"
                noOptionsText="Keine Labels vorhanden"
                noResultsText="Kein Label gefunden"

                :filterResults="false"
                :minChars="1"
                :resolveOnLoad="true"
                :delay="0"

                v-model="labels"
                :options="async function(query) {
    return await fetchLabels(query) // check JS block in JSFiddle for implementation
  }"
            >
                <template v-slot:tag="{ option, handleTagRemove, disabled }">
                    <div class="multiselect-tag " v-bind:class="option.color">
                        {{ option.label }}
                        <span
                            v-if="!disabled"
                            class="multiselect-tag-remove"
                            @mousedown.prevent="handleTagRemove(option, $event)"
                        >
            <span class="multiselect-tag-remove-icon"></span>
          </span>
                    </div>
                </template>
            </Multiselect> </div>
        </div>
    </div>
    </div>
</template>

<script>
import { StreamBarcodeReader } from "vue-barcode-reader";
import Multiselect from '@vueform/multiselect'
import Toast from 'primevue/toast';

export default {
    name: "YouryBarcode",
    components: {
        StreamBarcodeReader,
        Multiselect,
        Toast
    },
    data() {
        return {
            text: "",
            action: "",
            labels: [],
            competitions: [],
            competition:null,
            id: null,
            loaded: false,
        };
    },
    methods:{
        async fetchLabels(query) {
              const response = await axios.get(
                '/api/'+this.competition+'/labels'
            );
            return response.data.map((item) => {
                return { value: item.id, label: item.name, color:'bg-'+item.color }
            })
        },
        async fetchCompetitions() {
            const response = await axios.get(
                '/api/competitions'
            );
            return response.data.map((item) => {
                return { value: item.slug, label: item.name }
            })
        },
        setLabels(submissionId){
            axios.post('/api/submission/'+submissionId+'/labels', {
                labels: this.labels,
                operation: 'attach',
            })
                .then((resp)=> {
                    this.$toast.add({severity:'success', summary: 'Label(s) hinzugefügt', detail:'Die ausgewählten Labels wurden hinzugefügt.', life: 3000});

                })
                .catch( (error)=> {
                    this.$toast.add({severity:'error', summary: 'Aktion gescheitert', detail:'Die Labels konnten nicht hinzugefügt werden.', life: 3000});

                });
        },
        delete(submissionId,operation){
            axios.delete('/api/submission/'+submissionId+'/labels', {
                labels: this.labels,
                operation:operation
            })
                .then((resp)=> {
                    this.$toast.add({severity:'success', summary: 'Label(s) gelöscht', detail:'Die ausgewählten Labels wurden von der Einsendung entfernt.', life: 3000});

                })
                .catch( (error)=> {
                    this.$toast.add({severity:'error', summary: 'Aktion gescheitert', detail:'Die Labels konnten nicht gelöscht werden.', life: 3000});

                });
        },
         async findSubmission(slug,uid){
            return await axios.get('/api/'+slug+'/'+uid).then((res)=>{
                return res.data;
            }).catch((error)=>{
                if(error.response.status===404){
                    this.$toast.add({severity:'error', summary: 'Keine Einsendung gefunden ', detail:'Mit dem angegebenen Barcode wurde nichts gefunden.', life: 3000});
                }

            });

        },

        onDecode(a) {
            this.text = a;
            if (a.match(/^([a-zA-Z0-9]{1,}\.[a-z0-9A-Z]{3})$/)) {
                console.log('found barcode')
                const parts = a.split('.');
                const data=this.findSubmission(parts[0],parts[1]).then((res)=>{

                        if(this.action ==='redirect'){
                            window.location.href = "/team/einsendungen/"+res.id;
                        }
                        else if(this.action ==='redirect_windows'){
                            window.open("/team/einsendungen/"+res.id, '_blank')
                        }
                        else if(this.action ==='label_add'){
                           this.setLabels(res.id)
                        }
                        else if(this.action ==='label_remove'){
                            this.delete(res.id,'single')
                        }
                        else if(this.action ==='label_delete_all'){
                            this.delete(res.id,'all')
                        }else{
                            this.$toast.add({severity:'info', summary: 'Keine Aktion ausgewählt', detail:'', life: 3000});

                        }
                    }

                );

            }else{
                this.$toast.add({severity:'error', summary: 'Format nicht erkannt', detail:'Der Barcode ist nicht für youry geeignet', life: 3000});

            }
            if (this.id) clearTimeout(this.id);
            this.id = setTimeout(() => {
                if (this.text === a) {
                    this.text = "";
                }
            }, 5000);
        },
        onLoaded() {
            this.loaded=true;
        },
    }
}
</script>

<style scoped>

</style>
<style src="@vueform/multiselect/themes/default.css" scoped></style>
